import { Capacitor } from "@capacitor/core";

export type Platform = "web" | "ios" | "android";

export function platform(): Platform {
  const value = Capacitor.getPlatform();
  if (value === "ios" || value === "android") return value;
  return "web";
}

export function isNative(): boolean {
  return Capacitor.isNativePlatform();
}
